module.exports = __webpack_public_path__ + "crm_static/img/imgs_empty@2x.e9bf2578.png";